import { render, staticRenderFns } from "./Towers.vue?vue&type=template&id=10984436&scoped=true"
import script from "./Towers.vue?vue&type=script&lang=js"
export * from "./Towers.vue?vue&type=script&lang=js"
import style0 from "./Towers.vue?vue&type=style&index=0&id=10984436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10984436",
  null
  
)

export default component.exports